import { Component } from '@angular/core'

@Component({
  standalone: false,
  templateUrl: './archive-gate.component.html',
  styleUrls: ['./archive-gate.component.scss'],
})
export class ArchiveGateComponent {}
